module.exports = __webpack_public_path__ + "assets/img/4q.385fbe25.png";